import script from "./CheckoutDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./CheckoutDetails.vue?vue&type=script&lang=ts&setup=true"

import "./CheckoutDetails.vue?vue&type=style&index=0&id=8c2f3eda&lang=css"

const __exports__ = script;

export default __exports__